"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { creditEvaluation } from "@/content/agent-use-cases/credit-evaluation";

// Thin route wrapper — the catch-all maps a route to a component that takes only `locale`,
// so each available spoke gets a wrapper that binds its use-case data.
export default function CreditEvaluationUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={creditEvaluation} locale={locale} />;
}
